import throttle from 'lodash/throttle';

function isInViewportOrCloseEnoughToLoad(element) {
  // Special bonus for those using jQuery
  if (typeof jQuery !== 'undefined' && element instanceof jQuery)
    element = element[0];

  var rect = element.getBoundingClientRect();
  var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

  // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
  var vertInView = (rect.top <= (windowHeight + 400)) && ((rect.top + rect.height) >= 0);
  var horInView = (rect.left <= (windowWidth + 400)) && ((rect.left + rect.width) >= 0);

  return (vertInView && horInView);
}

export function lazyloadImage(element) {
  if (!isInViewportOrCloseEnoughToLoad(element)) {
    return;
  }
  var source = getSourceForSize(element);

  if (element.nodeName === 'IMG') {
    element.src = source;
    element.onload = function () {
      element.classList.add('lazy-loaded');
    }
  } else {
    var backgroundImage = 'url(' + source + ')';
    if (element.style.backgroundImage !== backgroundImage) {
      const tempEl = document.createElement('img');
      tempEl.src = source;
      tempEl.onload = function () {
        tempEl.remove(); // prevent memory leaks
        element.style.backgroundImage = backgroundImage;
        element.classList.add('lazy-loaded');
      }
    }
  }
}

export function lazyloadVideo(element) {
  if (!isInViewportOrCloseEnoughToLoad(element)) {
    return;
  }

  var src = getSourceForVideo(element);
  var isAbsoluteURL = src.slice(0, 4) === 'http';
  if (element.src !== src && (!isAbsoluteURL ? ((window.location.origin + src) !== element.src) : true)) {
    element.src = src;
  }
}

const VIDEO_SIZE_BREAKPOINTS = {
  0: 'srcPhone',
  768: 'srcDesktop',
  2200: 'srcFull',
};

function getSourceForVideo(element) {
  var elementWidth = element.parentElement.offsetWidth != 0 ? element.parentElement.offsetWidth : element.offsetWidth;

  if (element.dataset.useFull) {
    return element.dataset.srcFull;
  }

  var path = null;
  Object.keys(VIDEO_SIZE_BREAKPOINTS).forEach(function (breakpoint) {
    var key = VIDEO_SIZE_BREAKPOINTS[breakpoint];
    var sizePath = element.dataset[key];

    if (elementWidth >= breakpoint && !!sizePath) {
      path = sizePath;
    }
  });

  var portraitPath = element.dataset.srcPortrait;
  if (elementWidth < 540 && !!portraitPath && !window.matchMedia('(orientation: landscape)').matches) {
    path = portraitPath;
  }

  if (!path) {
    return element.dataset.srcFull;
  }

  return path;
}

var SIZE_BREAKPOINTS = {
  0: 'srcPhone',
  432: 'srcTablet',
  576: 'srcDesktop',
  768: 'srcWidescreen',
  1280: 'srcFull',
};

function getSourceForSize(element) {
  var elementWidth = element.parentElement.offsetWidth != 0 ? element.parentElement.offsetWidth : element.offsetWidth;

  if (element.dataset.useFull) {
    return element.dataset.srcFull;
  }

  var path = null;
  Object.keys(SIZE_BREAKPOINTS).forEach(function (breakpoint) {
    var key = SIZE_BREAKPOINTS[breakpoint];
    var sizePath = element.dataset[key];

    if (elementWidth >= breakpoint && !!sizePath) {
      if (window.outerWidth > 992 && key === "srcPhone") return;

      path = sizePath;
    }

  });

  var portraitPath = element.dataset.srcPortrait;
  if (elementWidth < 540 && !!portraitPath && !window.matchMedia('(orientation: landscape)').matches) {
    path = portraitPath;
  }

  if (!path) {
    return element.dataset.srcFull;
  }

  return path;
}

export function lazyloadAllImagesAndVideos() {
  // Loop over all classes that could use the lazy-loading script.
  var lazyloadImages = Array.prototype.slice.call(document.querySelectorAll('.lazy-loading'), 0);
  // Loop over all classes that could use the lazy-loading script.
  var lazyloadVideos = Array.prototype.slice.call(document.querySelectorAll(
      '.video-lazy-loading',
  ), 0);

  lazyloadImages.forEach((el) => lazyloadImage(el));
  lazyloadVideos.forEach(lazyloadVideo);
}

export function lazyloadImagesWhenReadyAndSetupListeners() {
  lazyloadAllImagesAndVideos();

  var throttledLazyLoad = throttle(lazyloadAllImagesAndVideos.bind(null), 100);
  document.addEventListener('scroll', throttledLazyLoad);
  window.addEventListener('resize', throttledLazyLoad);
  window.addEventListener('lazy-load-check', throttledLazyLoad);
  window.addEventListener('orientationChange', throttledLazyLoad);
}
